import React, { useState } from "react";
import { RiUserSettingsLine } from "react-icons/ri";
import { LiaSignOutAltSolid } from "react-icons/lia";
import { NavLink } from "react-router-dom";
import background from "../assests/images/Doodle Iamge.png";
import logo from "../assests/images/Texpidea Logo 1.png";
import nameapp from "../assests/images/texpidea-1@2x.png";
// import subscritionimg from "../assests/images/group-4@1x.png";
import Header from "../ModelDashboard/Header";


const Sidebar = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = window.location.pathname;
    console.log("pathname", pathname)
    const toggle = () => setIsOpen(!isOpen);
    const dashboaedcompoWidth = isOpen ? "100%" : "100%";
    const headersidebar = isOpen ? "100%" : "100%";
    const mainwidth = isOpen ? "100%" : "100%";


    const [currentPage, setCurrentPage] = useState(0);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const sidebarWidth = {
        'lg': {
            open: ":w-[310px]",
            closed: "w-[100px]",
        },
        "xl": {
            open: "w-[310px]",
            closed: "w-[104px]",
        },
        "2xl": {
            open: "w-[310px]",
            closed: "w-[104px]",
        },
    };

    const circleWidth = {
        'lg': {
            open: "w-[200px] h-[75px] ",
            closed: "w-[80px] h-[80px]",
        },
        "xl": {
            open: "w-[220px] h-[75px]",
            closed: "w-[90px] h-[90px]",
        },
        "2xl": {
            open: "w-[200px] h-[75px]",
            closed: "w-[70px] h-[70px]",
        },
    };
    const [activeMenuItem, setActiveMenuItem] = useState(null);

    const menuItem = [
        {
            path: "/modeldashboard",
            name: "Models ",
            icon: <RiUserSettingsLine className={`${pathname === "/modeldashboard" ? "text-[#FF9900]" : "text-white"}`} />,
        },

    ];

    const handleIconClick = (index) => {
        // Update the activeMenuItem and colorClass for the clicked item
        setActiveMenuItem(index);

        // Use the updated state value to set the colorClass
        const updatedMenuItems = menuItem.map((item, i) => ({
            ...item,
            colorClass: i === index ? "text-blue-500" : "text-white",
        }));

    };
    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.reload()
    };
    return (
        <div className="h-screen container-2xl">
            <div className="relative h-screen bg-center bg-cover shadow-md" style={{
                backgroundImage: 'radial-gradient(77.96% 148.88% at 50% -45.8%, #f90 0%, #00003f 100%)',
                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                position: 'relative',
            }}>
                <img src={background} alt="background" className="w-full h-screen" />

                <div className="absolute top-0 flex w-full ">
                    <div className="sidebarpage ">
                        <div

                            className={`sidebar text-white transition-all duration-500 ${isOpen ? sidebarWidth.lg.open : sidebarWidth.lg.closed
                                } lg:${isOpen ? sidebarWidth.xl.open : sidebarWidth.xl.closed} 2xl:${isOpen ? sidebarWidth["2xl"].open : sidebarWidth["2xl"].closed
                                }`}

                        >
                            <div className="flex items-center justify-center px-4 top_section  lg:py-7 xl:py-7 2xl:py-16">
                                <h1
                                    style={{ display: isOpen ? "block" : "none" }}
                                    className="text-3xl logo"
                                ></h1>

                                <div
                                    // style={{ marginLeft: isOpen ? "100px" : "10px" }}
                                    className="flex items-center justify-center "
                                >
                                    {/* <div className={`w-${isOpen ? '24' : '24'} h-${isOpen ? '24' : '24'} rounded-full  flex justify-center items-center  border border-white border-opacity-69 bg-white bg-opacity-45 backdrop-blur-[13.1px]`} onClick={toggle}> */}
                                    <div
                                        className=" rounded-full  flex justify-center items-center  border border-white border-opacity-69 bg-white bg-opacity-45 backdrop-blur-[13.1px]"

                                        style={{
                                            width: isOpen ? circleWidth.lg.open : circleWidth.lg.closed,
                                            '@media (min-width: 1280px)': {
                                                width: isOpen ? circleWidth.xl.open : circleWidth.xl.closed,
                                            },
                                            '@media (min-width: 2560px)': {
                                                width: isOpen ? circleWidth["2xl"].open : circleWidth["2xl"].closed,
                                            },
                                        }}
                                        onClick={toggle}
                                    > <div className="">
                                            <img
                                                src={logo}
                                                alt="logo"
                                                className="w-13 lg:w-16 xl:w-20 2xl:w-28"
                                            />
                                        </div>
                                        <div
                                            style={{ display: isOpen ? "block" : "none" }}
                                            className="pb-6 pr-4 lg:pb-3 xl:pb-5"
                                        >
                                            <img
                                                src={nameapp}
                                                alt="logo"
                                                className="w-19 lg:w-[120px] xl:w-32"
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="flex flex-col justify-center px-2 ">
                                {menuItem.map((item, index) => (
                                    <NavLink
                                        to={item.path}
                                        key={index}
                                        className={`sidebaricon flex space-x-5 lg:space-x-3 xl:space-x-5 2xl:space-x-5 items-center transition-all duration-500 border-t border-white ${activeMenuItem === index ? 'text-blue-500' : 'text-white'
                                            }`}
                                        activeClassName=""
                                        onClick={() => handleIconClick(index)}
                                    >
                                        <div className="flex justify-center items-center text-4xl py-3 pl-6 lg:py-3 lg:text-[22px] lg:pl-7 xl:pl-6 lg:pl-5 xl:text-3xl xl:py-[13px] text-3xl 2xl:text-6xl 2xl:pl-3 2xl:py-7">
                                            {item.icon} 
                                        </div>
                                        <div
                                            style={{ display: isOpen ? 'block' : 'none' }}
                                            className="text-2xl lg:text-[15px] xl:text-[16px] 2xl:text-3xl"
                                        >
                                            {item.name}
                                        </div>
                                    </NavLink>
                                ))}
                                <div className="border-t border-white borderbottom  cursor-pointer">
                                    <div className="signout flex flex-col items-center text-white pt-16 lg:pt-[60px]  xl:pt-[460px] 2xl:pt-[120px]"
                                        onClick={() => {
                                            const confirmLogout = window.confirm("Are you sure you want to sign out?");
                                            if (confirmLogout) {
                                                handleLogout()
                                            }
                                        }}>
                                        <LiaSignOutAltSolid className="text-2xl font-bold 2xl:text-3xl" transform="rotate(270)" />
                                        <p className="text-[13px] fw-2 2xl:text-[20px] ">Sign Out</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="flex flex-col h-screen "
                        style={{ width: dashboaedcompoWidth }}
                    >
                        <div
                            className=""
                            style={{ width: headersidebar }}
                        >
                            <Header />
                        </div>
                        <main className="" style={{ width: mainwidth }}>


                            <div className="h-[82vh] flex  bg-gray-300 ">
                                <div
                                    // style={{ borderRadius: '0px 0px 11px 11px' }}
                                    className="w-full">
                                    {children}
                                </div>
                            </div>

                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;